import { Skeleton } from "@mui/material";
import { PALETTE_LIGHT } from "@dexibit/styles";

const PageLoadingSkeleton = () => (
  <Skeleton
    variant="rectangular"
    animation="wave"
    width="100%"
    height="100%"
    sx={{
      bgcolor: PALETTE_LIGHT.COMPONENT_BORDER,
      "&::after": {
        background: `linear-gradient(90deg, transparent, ${PALETTE_LIGHT.SURFACE_BASE}, transparent)`,
      },
    }}
  />
);

export default PageLoadingSkeleton;
